import type { LessonStatusFilter } from "@memorang/ui/components/LessonsExploreScreen/types";
import { useCallback, useMemo, useState } from "react";
import { exploreModules } from "../constants";
import { lessonMatchesStatusFilter, toExploreLessons } from "../helpers";

export const useLessonsExplore = () => {
	const [statusFilter, setStatusFilter] = useState<LessonStatusFilter>("all");

	const lessons = useMemo(
		() =>
			toExploreLessons(exploreModules).filter((lesson) =>
				lessonMatchesStatusFilter(lesson, statusFilter),
			),
		[statusFilter],
	);

	const handleClearFilters = useCallback(() => {
		setStatusFilter("all");
	}, []);

	return {
		statusFilter,
		onChangeStatusFilter: setStatusFilter,
		lessons,
		totalLessons: exploreModules.length,
		onClearFilters: handleClearFilters,
	};
};
